import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  status: null,
  message: null,
  data: null,
};

const sectorPopularReducer = createReducer(initialState, {
  SECTOR_POPULAR_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  SECTOR_POPULAR_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  SECTOR_POPULAR_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default sectorPopularReducer;
